import { useSelector } from 'react-redux';
import { getCmsBySlug } from '../cms/cms-reducer';
import { didNotFetchShortLink, getShortLink } from '../shortlink/shortlink-actions';
import { isValidProjectId } from '../project/project-model';
import { fetchCMSbySlug } from '../cms/cms-actions';
import { getBlockComponentForContent } from '../utils/cms-utils';
import { useParams } from 'react-router-dom';
import { cachedRedirect } from '../utils/cache-utils';

const NoMatchOrRedirect = () => {
    const params = useParams();
    const cmsContent = useSelector((state) => getCmsBySlug(state, params.slug));
    if (cmsContent) {
        return getBlockComponentForContent({ data: cmsContent });
    }
    return null;
};

export const loader = async ({ dispatch, getState, params, request }) => {
    const url = new URL(request.url);
    const path = url.pathname?.substring(1);
    const decodedSlug = decodeURI(params?.slug);

    if (!isValidProjectId(path)) {
        const promises = [];
        const cmsFetch = dispatch(fetchCMSbySlug({ slug: decodedSlug }));
        promises.push(cmsFetch);

        if (!path.includes('/')) {
            promises.push(dispatch(getShortLink(path)));
        } else {
            promises.push(dispatch(didNotFetchShortLink()));
        }
        await Promise.all(promises);
    } else {
        await dispatch(didNotFetchShortLink());
    }

    const pathnames = (path || '').split('/');
    const projectId = isValidProjectId(pathnames[0]) ? pathnames[0] : null;
    const subprojectId = isValidProjectId(pathnames[1]) ? pathnames[1] : null;

    if (projectId && subprojectId) {
        return cachedRedirect(`/project/${projectId}?subproject=${subprojectId}`);
    } else if (projectId) {
        return cachedRedirect(`/project/${projectId}`);
    }

    const state = getState();
    const cmsContent = getCmsBySlug(state, decodedSlug);
    // CMS-innhold rendres av dette komponentet, så vi trenger ikke å redirecte
    if (cmsContent) {
        return;
    }

    const shortlink = state.shortlinks?.shortlink;
    if (shortlink) {
        if (shortlink?.project_id) {
            return cachedRedirect(`/project/${shortlink.project_id}`);
        } else if (shortlink?.organization_id) {
            return cachedRedirect(`/org/${shortlink.organization_id}`);
        } else if (shortlink.template_cause_id) {
            return cachedRedirect(`/cause/${shortlink.template_cause_id}`);
        } else if (shortlink.link && typeof shortlink.link === 'string') {
            return cachedRedirect(shortlink.link);
        }
    }

    if (path.includes('fallback-url')) {
        return cachedRedirect('/me');
    }

    throw new Response('Not found', { status: 404 });
};

export default NoMatchOrRedirect;
